import Icon from '../components/Icon.vue'

Icon.register({
  eraser: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.9 273.9l-142.1 142.1h144.1c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-356c-11 0-26.2-6.3-33.9-14.1l-96-96c-18.7-18.7-18.7-49.1 0-67.9l256-256c18.7-18.7 49.1-18.7 67.9 0l160 160c18.7 18.7 18.7 49.1 0 67.9zM195.3 211.3l-124.7 124.7 80 80h114.7l67.3-67.3z'
      }
    ]
  }
})
